<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-desktop page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2" onclick="Anvil.page.searchModal()"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4">
							<div class="row g-2">
								<div class="col d-none d-lg-block" style="width:380px;">
									<%- include('/ui/form', {
										params: [ 'search', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'company_group_id',
												title: 'Cég csoport',
												params: {
													maxItems: 1,
													options: [ { id: -1, name: '[ csoporton kívüli ]' }, ...company_groups.data ],
													valueField: 'id',
													labelField: 'name',
													searchField: [ 'name' ],
													render: {
														item: (item, esc) => `<div>${esc(item.name)}</div>`,
														option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
													},
													placeholder: '[ minden cégcsoport ]'
												},
												unset_value: null,
												prepend: '<span class="input-group-text"><i class="fa fa-city"></i></span>',
												append: '<button class="btn text-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.company_group_id = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto" style="width:300px; max-width:50vw;">
									<div class="input-group">
										<input type="text" class="form-control" id="text-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch()" />
										<span class="input-group-text"><i class="fa fa-search"></i></span>
									</div>
								</div>
							</div>
						</div>

						<h2>Terminálok</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">Terminálok</li>
						</ol>
					</div>

					<% for (const company_group of company_groups.data) { %>
						<h5><%= company_group.name %></h5>
						<% for (const company of company_group.companies) { %>
						<div class="card mb-2" style="background-color:rgb(60, 68, 74)">
							<div class="card-header p-2">
								<div class="row">
									<div class="col">
										<%= company.tax_number %><br />
										<strong><%= company.name %></strong><br />
										<small class="text-primary"><%= company_group.name %></small>
									</div>
								</div>
							</div>
							<% for (const company_db of company.company_dbs) { %>
							<div class="row g-0">
								<div class="col p-1">
									<div class="row g-1 text-success">
										<div class="col-auto">
											<button class="btn btn-dark"><i class="fa fa-fw fa-cloud text-success"></i></button>
										</div>
										<div class="col" style="line-height:1.4;">
											<strong><%= company_db.db_name %></strong><br />
											<small class="text-dim"><%= company_db.server %></small>
										</div>
									</div>
									<ul class="mb-0 branch server">
										<% for (const site of company_db.sites) { %>
										<li>
											<div class="card mt-1">
												<div class="card-header p-1">
													<div class="row g-1">
														<div class="col-auto">
															<button class="btn btn-dark" onclick="Anvil.page.openSite('<%- site.company_db_id %>', '<%- site.id %>')"><i class="fa fa-fw fa-<%- Anvil.models.c_order.Site.Types.find(t => t.value == site.type).icon%>"></i></button>
														</div>
														<div class="col" style="line-height:1.4;">
															<strong><%= site.name %></strong><br />
															<small><%- site.area_code ? `<span class="text-dim">${site.area_code}</span>` : '' %> <%= site.city || '' %><%- site.address ? `<span class="text-dim">, ${site.address}</span>` : '' %></small>
														</div>
													</div>
												</div>

												<div class="py-1">
													<% for (const storage of site.storages) { %>
													<table class="table table-dark table-hover table-sm grid-table">
														<thead>
															<th width="1" valign="top" style="color:tan;">Raktár:</th>
															<th width="50%">
																<div class="row g-0">
																	<div class="col-12 col-lg-6 col-xl-3" style="color:tan;">
																		<%= storage.name %>
																	</div>
																	<div class="col-12 col-lg-6 col-xl-3">
																		NTAK
																		<% if (storage.ntak_cert) { %>
																			<% if (storage.ntak_cert.sandbox == '1') { %>
																				<span class="text-info" title="<%- Anvil.moment(storage.ntak_cert.validto_time).format('YYYY. MM. DD. HH:mm') %>"><i class="fa fa-fw fa-certificate"></i> <%= storage.ntak_cert.regnumber %> <strong>Teszt</strong></span>
																			<% } else { %>
																				<span class="text-success" title="<%- Anvil.moment(storage.ntak_cert.validto_time).format('YYYY. MM. DD. HH:mm') %>"><i class="fa fa-fw fa-certificate"></i> <%= storage.ntak_cert.regnumber %></span>
																			<% } %>
																		<% } else { %>
																			<span class="text-danger"><i class="fa fa-fw fa-certificate"></i> Nincs</span>
																		<% } %>
																	</div>
																</div>
															</th>
															<th colspan="2"></th>
														</thead>
														<tbody>
															<% for (const terminal of storage.terminals) { %>
															<tr>
																<td width="1">
																	<div class="dropend">
																		<button class="btn btn-dark" data-bs-toggle="dropdown"><i class="fa fa-fw fa-desktop text-primary"></i></button>
																		<ul class="dropdown-menu">
																			<li>
																				<button class="dropdown-item py-2" onclick="Anvil.page.openTerminal('<%- terminal.machine_id %>')"><i class="fa fa-fw fa-folder-open me-2"></i>Megnyitás</button>
																			</li>
																			<hr class="my-1" />
																			<li>
																				<% if (terminal.anydesk_id) { %>
																				<button class="dropdown-item py-2" onclick="Anvil.page.connect_with_anydesk('<%- terminal.machine_id %>')"><i class="fa fa-fw fa-headset text-warning me-2"></i>Anydesk kapcsolat</button>
																				<% } else { %>
																				<button class="dropdown-item py-2 disabled"><i class="fa fa-fw fa-headset text-dim me-2"></i>Anydesk kapcsolat</button>
																				<% } %>
																			</li>
																		</ul>
																	</div>
																</td>
																<td width="50%">
																	<div class="row g-0">
																		<div class="col-12 col-xl-3">
																			<strong class="text-primary"><%= terminal.device_info.hostname %></strong><br />
																			<%
																			const online = Anvil.moment().subtract(2, 'minutes').isBefore(Anvil.moment(terminal.last_report_dt))
																			const warn = (terminal.remote_settings && terminal.remote_settings.warning_mode && terminal.remote_settings.warning_mode != 'none')
																			%>
																			<% if (online) { %>
																				<span class="badge bg-success text-light">online</span>
																			<% } %>
																			<% if (warn) { %>
																				<span class="badge bg-warning text-dark">figyelmeztetés</span>
																			<% } %>
																		</div>
																		<div class="col-12 col-xl-3">
																			<span class="d-lg-none responsive-label">NTAK:</span>
																			<% if (terminal.settings) { %>
																				<% if (terminal.settings.ntak_enabled == 'on') { %>
																					<span class="text-success"><i class="fa fa-fw fa-university"></i> Éles</span>
																				<% } else if (terminal.settings.ntak_enabled == 'prepare') { %>
																					<span class="text-secondary"><i class="fa fa-fw fa-cog fa-spin"></i> Készül</span>
																				<% } %>
																			<% } %>
																		</div>
																		<div class="col-12 col-xl-3">
																			<span class="d-lg-none responsive-label">Verzió:</span> <strong class="text-<%- Anvil.models.c_order.Versions.colors[Anvil.page.versions.verstate(terminal.version)] %>"><%= terminal.version %></strong>
																			<% if (terminal.update_channel == 'stable') { %>
																				<span class="text-<%- Anvil.models.c_order.Versions.colors['stable'] %>"><i class="fa fa-angle-right"></i> Stabil</span>
																			<% } else if (terminal.update_channel == 'beta') { %>
																				<span class="text-<%- Anvil.models.c_order.Versions.colors['beta'] %>"><i class="fa fa-angle-double-right"></i> Béta</span>
																			<% } else if (terminal.update_channel == 'alpha') { %>
																				<span class="text-<%- Anvil.models.c_order.Versions.colors['alpha'] %>"><i class="fa fa-bug"></i> Alpha</span>
																			<% } else { %>
																				<span class="text-dim"><i class="fas fa-times"></i> Stop</span>
																			<% } %>
																		</div>
																		<div class="col-12 col-xl-3">
																			<span class="d-lg-none responsive-label">Havidíj:</span> <strong style="color:goldenrod;"><%- Anvil.numeral(terminal.licence_fee).format('0,0') %></strong><br />
																			<% if (terminal.partner_dividend > 0) { %>
																			<span class="d-lg-none responsive-label">Jutalék:</span> <strong style="color:peru;">-<%- Anvil.numeral(terminal.partner_dividend).format('0,0') %></strong>
																			<% } %>
																		</div>
																	</div>
																</td>

																<% if (terminal.default_cashreg_ap) { %>
																<td width="1">
																	<button class="btn btn-dark" data-bs-toggle="dropdown"><i class="fa fa-fw fa-cash-register text-primary"></i></button>
																</td>
																<td width="50%">
																	<%= terminal.default_cashreg_ap %><br />
																</td>
																<% } else { %>
																<td width="1"></td>
																<td width="50%"></td>
																<% } %>
															</tr>
															<% } %>
														</tbody>
													</table>
													<% } %>
												</div>
											</div>
										</li>
										<% } %>
									</ul>
								</div>
							</div>
							<% } %>
						</div>
						<% } %>
						<hr />
					<% } %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	async connect_with_anydesk (machine_id) {

		// Find terminal
		const terminal = Anvil.page.terminals.getByMachineId(machine_id)
		if (terminal !== undefined) {
			// Request confirmation
			Anvil.confirm({
				title: 'Anydesk kapcsolat',
				message: `
					<p>Biztosan szeretnél csatlakozni a kiválasztott terminálhoz?</p>
					<table style="font-size:0.9em;">
						<tr>
							<td class="pe-3">Cég</td>
							<td><strong>${terminal.company_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3">Telephely</td>
							<td><strong>${terminal.site_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3" valign="top">Terminál</td>
							<td><strong>${terminal.device_info.hostname || terminal.name}</strong><br /><br /></td>
						</tr>
						<tr>
							<td class="pe-3">Anydesk ID</td>
							<td><strong>${terminal.anydesk_id}</strong></td>
						</tr>
					</table>
				`,
				btn_ok: `<i class="fa fa-headset me-2"></i>Csatlakozás`,
				btn_cancel: `<i class="fa fa-running me-2"></i>Mégse`,
				btn_ok_class: 'warning',
				onclose: (confirmed) => {
					if (confirmed) {
						window.open(`anydesk:${terminal.anydesk_id}`, '_self')
					}
				}
			})
		}
	},

	async sign_in_to_cloud (db_name) {
		const token = await Anvil.exec('c_order/company_db/action_get_sign_in_token', db_name)
		if (token) {
			window.open(`https://ugyfel.c-store.eu/sys_login_1.html?CEGID=${db_name}&logintoken=${token}`, '_blank')
		}
	},

	openSite (company_db_id, site_id) {
		Anvil.exec('c_order/site/modal_edit', company_db_id, site_id)
	},

	openTerminal (machine_id) {
		const terminal = Anvil.page.terminals.getByMachineId(machine_id)
		Anvil.exec('c_order/terminal/modal_edit', terminal)
	},
})

$('#terminal_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
